module.exports = __webpack_public_path__ + "static/media/8777.99ecdaba.png";